/**
 * The words of the role editor's Capabilities section (piece 8; decision 10300,
 * T769): one short label per seeded capability key, the section's heading and
 * hint, and the refusal a key outside the registry meets. Spread into the one
 * string lookup. The labels of `deals.askClaude` and `site.taxExempt.set` keep
 * their keys from decisions 6004 and 10210.
 */
export const CAPABILITY_STRINGS = {
  'settings.roles.capabilitiesTitle': 'Capabilities',
  'settings.roles.capabilitiesHint': 'Each tick lets a person in this role do one thing the module grid cannot say: see a work queue, or take one guarded step. Settings › People › Roles is the one place a role is given one.',
  'settings.roles.capabilitiesSuperAdmin': 'The super admin role holds every capability, so its ticks are shown and cannot be changed here.',
  'settings.roles.capabilityUnknown': 'A role is given only the capabilities this screen lists, and {keys} is not one of them. Remove it and save again.',
  'settings.roles.capability.approvals.view': 'Sees Pending Approvals',
  'settings.roles.capability.mail.quarantine.review': 'Reviews quarantined mail',
  'settings.roles.capability.files.classify': 'Classifies files waiting for a class',
  'settings.roles.capability.locations.edit': 'Reviews addresses needing review',
  'settings.roles.capability.leads.review': 'Reviews held leads and leads in no territory',
  'settings.roles.capability.nda.review': 'Reviews NDAs',
  'settings.roles.capability.nda.activate': 'Activates an NDA',
  'settings.roles.capability.hr.orgchart.edit': 'Edits the org chart and its reporting line exceptions',
  'settings.roles.capability.hr.hire': 'Hires, and sees new workers and jurisdictions from ADP',
  'settings.roles.capability.hr.discipline.deliver': 'Delivers write-ups',
  'settings.roles.capability.creditnote.receive': 'Receives returns against credit notes',
  'settings.roles.capability.admin.operations': 'Runs Settings and resolves operation failures',
  'settings.roles.capability.time.approve': 'Approves time and overtime',
  'settings.roles.capability.deals.commission.edit': 'Decides commission splits',
  'settings.roles.capability.documents.inbox.review': 'Works the documents inbox',
  'settings.roles.capability.duplicates.review': 'Reviews duplicate records',
  'settings.roles.capability.records.dataquality.review': 'Reviews records needing data review',
  'settings.roles.capability.todos.role.view': 'Sees the role’s to-dos',
  'settings.roles.capability.accounting.post': 'Posts to the ledger and works its queues',
  'settings.roles.capability.site.addForAnyAccount': 'Adds a site to any account',
  'settings.roles.capability.reports.projectperformance.view': 'Sees the Project Performance dashboard',
  'settings.roles.capability.vendor.w9.override': 'Overrides a vendor’s missing W-9',
  'settings.roles.capability.bom.costChange.override': 'Saves a costed bill of materials change after its quote went out',
  'settings.roles.capability.records.links.delete': 'Deletes a link made by mistake',
  'settings.roles.capability.logins.createInternal': 'Creates a login for our own people',
  'settings.roles.capability.logins.createExternal': 'Creates a login for someone at another company',
  'settings.roles.capability.hr.employees.view': 'Opens HR and its employee pages',
  'settings.roles.capability.hr.policy.review': 'Reviews policy text',
  'settings.roles.capability.workorder.time.typed': 'Records time by hand on a work order line',
  'settings.roles.capability.files.releaseUnowned': 'Releases a file nobody owns',
  'settings.roles.capability.calls.answer': 'Answers the company number',
} as const;
